import block from './block.json';

export const listAccordionsThemeAttributes = {
	margin: {
		top: [16, 32],
		bottom: [16, 32],
	},
	grid: {
		gap: [16, 32],
	},
};

export const ListAccordionsThemeControls: ThemeControlsType = {
	// What's displayed
	title: block.title,

	// Unique string/id of the block (= the key used in theme.json)
	slug: block.slug,

	// styling attributes available for this block
	// ...the same way we define attributes for a gutenberg block
	attributes: listAccordionsThemeAttributes,

	// this renders in the Customizer panel
	// ...the same way "<InspectorControls />" renders in the gutenberg panel
	edit: () => null,
};
